module.exports = __webpack_public_path__ + "pc/img/body_basic 12.1c693813.jpg";